module.exports = __webpack_public_path__ + "img/cww_04.fd8e0d38.jpg";